export const EMPTY_FORM = {
  prefix: '',
  tier: '5',
  nestingRelationships: [],
  accessoryNesting: [],
  nestingRestrictions: [],
  'flags.cannotBeContained': false,
  'flags.accessoriesOnlyContainer': false,
  'flags.isAccessory': false,
  'flags.cannotBeNested': false,
  sizeOrder: '',
  active: true,
}

export const MAX_TREE_DEPTH = 24
export const TREE_DEPTH_PX = 14
export const TREE_BASE_PAD = 10
export const SEARCH_SUPPLEMENTARY_MIN_TIER = 4
export const EMPTY_SUPPLEMENTARY_ROOTS = Object.freeze(new Set())
export const TREE_ROW_GRID_WITH_TIER = '1.5rem minmax(0,10rem) max-content minmax(6.5rem,max-content)'
export const TREE_ROW_GRID_WITHOUT_TIER = '1.5rem minmax(0,14rem) minmax(6.5rem,max-content)'
export const TREE_ROW_GRID_CLASS =
  'grid w-full min-w-0 items-center justify-items-stretch gap-x-1.5 gap-y-0 py-1.5 pr-44 sm:pr-48'
export const CONTAINER_TREE_ROOT_MAX_TIER = 3
export const LABEL_CAN_PACK_INTO = 'Can be packed into:'
export const PREFIX_FILTER_ALL = '__all_prefixes__'
export const UNKNOWN_TIER_VALUE = '99'
export const UNKNOWN_TIER_LABEL = 'T99 - Unknown tier (needs update)'

export const TIER_STYLES = {
  1: { badge: '#dbeafe', border: '#93c5fd', text: '#1e3a8a', panel: '#eff6ff' },
  2: { badge: '#dcfce7', border: '#86efac', text: '#14532d', panel: '#f0fdf4' },
  3: { badge: '#fef3c7', border: '#fcd34d', text: '#78350f', panel: '#fffbeb' },
  4: { badge: '#fce7f3', border: '#f9a8d4', text: '#831843', panel: '#fdf2f8' },
  5: { badge: '#ede9fe', border: '#c4b5fd', text: '#4c1d95', panel: '#f5f3ff' },
  6: { badge: '#ccfbf1', border: '#5eead4', text: '#134e4a', panel: '#f0fdfa' },
  7: { badge: '#fee2e2', border: '#fca5a5', text: '#7f1d1d', panel: '#fef2f2' },
  unknown: { badge: '#f1f5f9', border: '#cbd5e1', text: '#334155', panel: '#f8fafc' },
}
